import { l as logger } from "./logger-D3RVzcfQ.mjs";
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var _a$1, _b$1;
(_a$1 = window._vue_richtext_widgets) != null ? _a$1 : window._vue_richtext_widgets = {};
(_b$1 = window._registerWidget) != null ? _b$1 : window._registerWidget = (id, callback, onDestroy, props) => {
  registerWidget(id, callback, onDestroy, props);
};
function registerWidget(id, callback, onDestroy = () => {
}, props) {
  const propsWithDefaults = __spreadValues({
    hasInteractiveView: true,
    fullWidth: false
  }, props);
  if (window._vue_richtext_widgets[id]) {
    logger.error("[ReferencePicker]: Widget for id ".concat(id, " already registered"));
    return;
  }
  window._vue_richtext_widgets[id] = __spreadValues({
    id,
    callback,
    onDestroy
  }, propsWithDefaults);
}
function renderWidget(el, options) {
  const { richObjectType, richObject, accessible, interactive } = options;
  if (richObjectType === "open-graph") {
    return;
  }
  if (!window._vue_richtext_widgets[richObjectType]) {
    logger.error("Widget for rich object type " + richObjectType + " not registered");
    return;
  }
  window._vue_richtext_widgets[richObjectType].callback(el, { richObjectType, richObject, accessible, interactive });
}
function destroyWidget(richObjectType, el) {
  if (richObjectType === "open-graph") {
    return;
  }
  if (!window._vue_richtext_widgets[richObjectType]) {
    return;
  }
  window._vue_richtext_widgets[richObjectType].onDestroy(el);
}
function isWidgetRegistered(id) {
  return !!window._vue_richtext_widgets[id];
}
function hasInteractiveView(id) {
  var _a2;
  return !!((_a2 = window._vue_richtext_widgets[id]) == null ? void 0 : _a2.hasInteractiveView);
}
function hasFullWidth(id) {
  var _a2;
  return !!((_a2 = window._vue_richtext_widgets[id]) == null ? void 0 : _a2.fullWidth);
}
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _a, _b;
(_a = window._vue_richtext_custom_picker_elements) != null ? _a : window._vue_richtext_custom_picker_elements = {};
(_b = window._registerCustomPickerElement) != null ? _b : window._registerCustomPickerElement = registerCustomPickerElement;
class NcCustomPickerRenderResult {
  /**
   * @param element - The HTML element
   * @param object - The object
   */
  constructor(element, object) {
    __publicField(this, "element");
    __publicField(this, "object");
    this.element = element;
    this.object = object;
  }
}
function isCustomPickerElementRegistered(id) {
  return !!window._vue_richtext_custom_picker_elements[id];
}
function getCustomPickerElementSize(id) {
  var _a2;
  const size = (_a2 = window._vue_richtext_custom_picker_elements[id]) == null ? void 0 : _a2.size;
  if (["small", "normal", "large", "full"].includes(size)) {
    return size;
  }
  return null;
}
function registerCustomPickerElement(id, callback, onDestroy = () => {
}, size = "large") {
  if (window._vue_richtext_custom_picker_elements[id]) {
    logger.error("Custom reference picker element for id ".concat(id, " already registered"));
    return;
  }
  window._vue_richtext_custom_picker_elements[id] = {
    id,
    callback,
    onDestroy,
    size
  };
}
function renderCustomPickerElement(el, options) {
  const { providerId, accessible } = options;
  if (!window._vue_richtext_custom_picker_elements[providerId]) {
    logger.error("Custom reference picker element for reference provider ID ".concat(providerId, " not registered"));
    return;
  }
  return window._vue_richtext_custom_picker_elements[providerId].callback(el, { providerId, accessible });
}
function destroyCustomPickerElement(providerId, el, renderResult) {
  if (!window._vue_richtext_custom_picker_elements[providerId]) {
    return;
  }
  window._vue_richtext_custom_picker_elements[providerId].onDestroy(el, renderResult);
}
export {
  NcCustomPickerRenderResult as N,
  renderWidget as a,
  destroyCustomPickerElement as b,
  isCustomPickerElementRegistered as c,
  destroyWidget as d,
  registerCustomPickerElement as e,
  renderCustomPickerElement as f,
  getCustomPickerElementSize as g,
  hasInteractiveView as h,
  isWidgetRegistered as i,
  hasFullWidth as j,
  registerWidget as r
};
//# sourceMappingURL=customPickerElements-BPROmh4T.mjs.map
